import { Component, OnInit, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'panel-container',
  templateUrl: './panel-container.component.html',
  styleUrls: ['./panel-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PanelContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
